const {
  LOAD_USER,
  LOAD_USER_ERROR,
  LOAD_USER_SUCCESS,
  SAVE_USER,
  SAVE_USER_ERROR,
  SAVE_USER_SUCCESS
} = require("../actions/user");

const userState = (loading = false, data = {}, error = "") => ({
  loading,
  data,
  error
});

export default function(state = userState(), { type, payload }) {
  switch (type) {
    case LOAD_USER:
      return userState(true);
    case LOAD_USER_ERROR:
      return userState(false, state.data, payload);
    case LOAD_USER_SUCCESS:
      return userState(false, payload);
    case SAVE_USER:
      return userState(true, Object.assign({}, state.data, payload));
    case SAVE_USER_ERROR:
      return userState(false, state.data, payload);
    case SAVE_USER_SUCCESS:
      return userState(false, state.data);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/user.js